import { get } from '../Services/http';
import { catchError } from './Error.action';
import {
  receiveProductsWrapper,
  setCurrentProductsCount,
  setTotalProducts,
} from './LoadMore.action';
import {
  FACETED_SEARCH_QUERY,
  FACETED_SEARCH_RECEIVE,
  FACETED_SEARCH_ERROR,
  FACETED_SEARCH_TOGGLE_VALUE,
  FACETED_SEARCH_TOGGLE_COMPACT,
  PRODUCT_VIEW_CACHED,
  PRODUCTS_RECEIVE_PRODUCTS_WRAPPER,
} from '../constants';
import { pushEcommerce } from '../Services/Gtm.service';

export const query = (
  queryString = '',
  withHtmlResult = true,
  productsViewCachedId = new Date().getTime() + '',
  shouldDispatchToLoadMore = true
) => (dispatch, getState) => {
  let url = withHtmlResult
    ? '/api/productFilter/withHtmlResult'
    : '/api/productFilter';
  if (queryString && queryString.trim() !== '') {
    url += `?${queryString}`;
  }
  return get(url)
    .then((response) => response.json())
    .then((result) => {
      const { productsView, sortCriteria, subNavigation, ...others } = result;
      const productsWrapper = result.products;
      if (withHtmlResult) {
        dispatch(receiveProductsWrapper(result.products));
      }
      result = {
        ...others,
        sortCriteria,
        subNavigation,
        productsViewCachedId,
      };

      if (shouldDispatchToLoadMore) {
        dispatch(setCurrentProductsCount(productsWrapper?.products?.length || 0));
      }

      dispatch(setTotalProducts(productsWrapper?.pagination?.totalCount || result.totalCount || 0));
      dispatch(receive(result));

      try {
        if (result.gtmViewModel !== null) {
          pushEcommerce(result.gtmViewModel);
        }
      } catch (err) {
        console.log(err);
      }
    })
    .catch((ex) => dispatch(catchError(ex, (error) => searchError(error))));
};

const toReducedGroupedFilters = (flattenedUrlParameters) => {
  const reducedGroupedFilters = flattenedUrlParameters.reduce(
    (result, filter) => {
      const prefixGroupName = filter.split('=')[0];
      const value = filter.split('=')[1];
      result[prefixGroupName] = result[prefixGroupName] || [];
      result[prefixGroupName].push(value);
      return result;
    },
    {}
  );
  return reducedGroupedFilters;
};

const submit = (facetFilters) => (dispatch, getState) => {
  const filterCriteria = toFilterCriteria(facetFilters);
  const filterIds = facetFilters.map((filter) => filter.id);
  const ignoredParams = ['page', 'products'];
  const unChangedParams = (window.location.search.substr(1) || '')
    .split('&')
    .filter((param) => {
      const [id, value] = param.split('=');
      return (
        param.length > 0 &&
        !filterIds.includes(id) &&
        !ignoredParams.includes(id)
      );
    });
  const q = [...unChangedParams, ...filterCriteria].join('&');
  dispatch(saveQuery(q));
  return dispatch(query(q));
};

const toGroupedFilters = (reducedGroupedFilters, groups) => {
  let groupedFilters = [];

  Object.keys(reducedGroupedFilters).filter((groupName) => {
    var sortedFilterGroup = reducedGroupedFilters[groupName].sort(
      (a, b) => a - b
    );
    let groupIsSlider = groups.find((group) => group.id == groupName)?.asSlider;
    if (groupIsSlider) {
      if (sortedFilterGroup.length == 1) {
        groupedFilters.push(
          `${groupName}=${sortedFilterGroup[0] + '-' + sortedFilterGroup[0]}`
        );
      } else {
        groupedFilters.push(`${groupName}=${sortedFilterGroup.join('-')}`);
      }
    } else {
      reducedGroupedFilters[groupName].forEach((y) =>
        groupedFilters.push(`${groupName}=${y}`)
      );
    }
  });

  return groupedFilters;
};

const toGroupedFilterCriteria = (flattenedUrlParameters, groups) => {
  let groupedFilters = [];
  var reducedGroupedFilters = toReducedGroupedFilters(flattenedUrlParameters);
  if (reducedGroupedFilters != null) {
    return toGroupedFilters(reducedGroupedFilters, groups);
  }
  return groupedFilters;
};

const toFilterCriteria = (groups) =>
  groups
    .map((group) =>
      group.selectedOptions
        .filter((val) => val && val.length > 0)
        .map(
          (val) => `${encodeURIComponent(group.id)}=${encodeURIComponent(val)}`
        )
    )
    .reduce((flat, current) => [...flat, ...current], []);

/**
 *
 * @param filter : the group has changed facet
 * @param option : changed facet
 */
export const searchFacetChange = (filter = null, option = null) => (
  dispatch,
  getState
) => {
  if (filter) {
    const allFilters = getState().facetedSearch.facetFilters;
    const newFilters = updateFilterOption(allFilters, filter, option);
    return dispatch(submit(newFilters));
  }
};

export const updateFilterOption = (
  allFilters = [],
  filter = null,
  option = null
) => {
  if (!filter) return allFilters;
  const filterIndex = allFilters.findIndex((f) => f.id === filter.id);
  const newFilter = option
    ? toggleFilterValue(filter, option)
    : { ...filter, selectedOptions: [] };
  const newFilters = [
    ...allFilters.slice(0, filterIndex),
    newFilter,
    ...allFilters.slice(filterIndex + 1),
  ];
  return newFilters;
};

const toggleFilterValue = (filter, option) => {
  const { singleSelect, selectedOptions } = filter;
  const optionIndex = selectedOptions.indexOf(option.id);
  const newSelectedOptions =
    optionIndex < 0
      ? // not yet selected, select it
        singleSelect
        ? [option.id]
        : [...selectedOptions, option.id]
      : // selected, deSelect  it
        [
          ...selectedOptions.slice(0, optionIndex),
          ...selectedOptions.slice(optionIndex + 1),
        ];
  return { ...filter, selectedOptions: newSelectedOptions };
};

export const submitSearchFacet = (allFilters) => (dispatch, getState) => {
  dispatch(facetClientChanged(allFilters));
  return dispatch(submit(allFilters));
};

export const facetClientChanged = (facetFilters) => ({
  type: FACETED_SEARCH_TOGGLE_VALUE,
  payload: {
    facetFilters,
  },
});

export const toggleVisibleDropdownMenu = ({ id }) => ({
  type: FACETED_SEARCH_TOGGLE_COMPACT,
  payload: {
    visibleDropdownMenu: id,
  },
});

export const searchError = (error) => ({
  type: FACETED_SEARCH_ERROR,
  payload: {
    error,
  },
});

export const receive = (payload) => {
  return {
    type: FACETED_SEARCH_RECEIVE,
    payload,
  };
};

export const saveQuery = (queryString) => ({
  type: FACETED_SEARCH_QUERY,
  payload: {
    query: queryString,
  },
});

export const setProductsInProductsView = (products) => ({
  type: PRODUCTS_RECEIVE_PRODUCTS_WRAPPER,
  payload: {
    productsWrapper: {
      products,
    },
  },
});

export const onSortCriteriaChanged = (query) => (dispatch, getState) => {
  const facetedSearchState = getState().facetedSearch;
  const sortCriteria = facetedSearchState.sortCriteria;
  const selectedItem = sortCriteria?.sortItems.find((i) => i.query == query);
  if (!selectedItem) return;
  const sortQuery = new URLSearchParams(selectedItem.query);
  const currentQuery = new URLSearchParams(location.search);
  const sortBy = sortQuery.get('sort_by');
  const sortDirection = sortQuery.get('sort_direction');
  if (!!sortBy) {
    currentQuery.set('sort_by', sortBy);
    currentQuery.set('sort_direction', sortDirection);
  } else {
    currentQuery.delete('sort_by');
    currentQuery.delete('sort_direction');
  }
  history.pushState('sort', null, '?' + currentQuery.toString());
  dispatch(submitSearchFacet(facetedSearchState.facetFilters));
};

export const clearFilterGroup = (filterGroupId) => (dispatch, getState) => {
  const facetFilters = getState().facetedSearch.facetFilters;
  const filtersCopy = Object.assign([], facetFilters);
  const filterGroup = filtersCopy.find((f) => f.id == filterGroupId);
  if (!filterGroup) return;
  filterGroup.selectedOptions = [];
  dispatch(submitSearchFacet(filtersCopy));
};

export const clearAllFilters = () => (dispatch, getState) => {
  const facetFilters = getState().facetedSearch.facetFilters;
  const filtersCopy = Object.assign([], facetFilters);
  for (let filter of filtersCopy) {
    filter.selectedOptions = [];
  }
  dispatch(submitSearchFacet(filtersCopy));
};
